export default __webpack_public_path__ + "static/media/lhd-performance-hero-desktop.5c361c9c.jpg";